/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./AgreementNotification.css";

export default function AgreementNotification({ onClose, onClick }) {
  return (
    <div className="agreement-notification-container">
      <div className="notification-banner">
        <div className="notification-content">
          <span className="notification-text">
            The Developer Agreement has been updated. Please review and accept the new terms to continue using the marketplace.
          </span>
          <button className="notification-action-btn" onClick={onClick}>
            View Agreement
          </button>
        </div>
        <IconButton
          aria-label="close"
          className="notification-close-btn"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
}

AgreementNotification.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};
